document.addEventListener("DOMContentLoaded", () => {
  // slider gallery home
  var swipergallery = new Swiper(".swiper-container-gallery", {
    slidesPerView: 1,
    spaceBetween: 0,

    loop: true,
    pagination: {
      el: ".swiper-pagination-gallery",
      clickable: true
    },
    autoplay: {
      delay: 3500
    },
    navigation: {
      nextEl: ".swiper-button-next-gallery",
      prevEl: ".swiper-button-prev-gallery"
    }
  });

  ////// FIRST SLIDER HOME-SEAB

  let swiper_SEAB = new Swiper(".swiper-container-SEAB", {
    pagination: {
      el: ".swiper-pagination-SEAB",
      clickable: true
    },
    autoHeight: true,
    autoplay: {
      delay: 4000
    },
    navigation: {
      nextEl: ".swiper-button-next-SEAB",
      prevEl: ".swiper-button-prev-SEAB"
    }
  });

  // slider foundations home
  let width = window.innerWidth;
  let slider_config = {
    slidesPerView: 2,
    spaceBetween: 8,
    slidesPerGroup: 1,
    loop: true,
    // centeredSlides: true,
    loopFillGroupWithBlank: true,
    pagination: {
      el: ".swiper-pagination-foundation",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next-foundation",
      prevEl: ".swiper-button-prev-foundation"
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    breakpoints: {
      // when window width is >= 1025px
      1025: {
        slidesPerView: 4,
        spaceBetween: 30
      }
    }
  };
  if (
    (width <= 1024 && drupalSettings.total_slides <= 2) ||
    (width > 1024 && drupalSettings.total_slides <= 4)
  ) {
    slider_config.loop = false;
  }
  let swiperfoundation = new Swiper(
    ".swiper-container-foundation",
    slider_config
  );

  // slider interna cancilleria

  var swiper_chancellery = new Swiper(".swiper-container-chancellery", {
    loop: true,
    loopFillGroupWithBlank: true,
    slidesPerView: 1,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: ".swiper-button-next-chancellery",
      prevEl: ".swiper-button-prev-chancellery"
    }
  });

  // Slider home -parishes

  let swiper_principal_gallery = new Swiper(
    ".swiper-container-principal-gallery2",
    {
      loop: true,
      loopFillGroupWithBlank: false,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: ".swiper-button-next-principal-gallery",
        prevEl: ".swiper-button-prev-principal-gallery"
      },
      breakpoints: {
        // when window width is >= 1025px
        768: {
          slidesPerView: 3,
          spaceBetween: 5
        },
        1600: {
          slidesPerView: 4,
          spaceBetween: 0
        }
      }
    }
  );
});

////// slider noticias relacionadas

const mdq = window.matchMedia("(max-width: 768px)");
const initSwiperInformationNews = e => {
  let swiperNews = false;

  if (e.matches) {
    swiperNews = new Swiper(".swiper-container-information-news", {
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination-information-news",
        clickable: true
      },
      autoplay: {
        delay: 4000
      }
    });
  } else {
    if (!!swiperNews) {
      swiperNews.destroy(true, true);
    }
  }
};
mdq.addListener(initSwiperInformationNews);
initSwiperInformationNews(mdq);

////// slider Otros Boletines y articulos relacionados

const mdqa = window.matchMedia("(max-width: 768px)");
const initSwiperInformationNewsletters = e1 => {
  let swiperNewsletters = false;

  if (e1.matches) {
    swiperNewsletters = new Swiper(".swiper-container-latest-newsletters", {
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination-latest-newsletters",
        clickable: true
      },
      autoplay: {
        delay: 4000
      }
    });
  } else {
    if (!!swiperNewsletters) {
      swiperNewsletters.destroy(true, true);
    }
  }
};
mdqa.addListener(initSwiperInformationNewsletters);
initSwiperInformationNewsletters(mdqa);

///// FIRST SLIDER HOME-SEAB
var swiper_SEAB = new Swiper(".swiper-container-SEAB", {
  pagination: {
    el: ".swiper-pagination-SEAB"
  }
});
